import { render, staticRenderFns } from "./PhotosAndDocuments.vue?vue&type=template&id=1988d3c8&scoped=true"
import script from "./PhotosAndDocuments.vue?vue&type=script&lang=js"
export * from "./PhotosAndDocuments.vue?vue&type=script&lang=js"
import style0 from "./PhotosAndDocuments.vue?vue&type=style&index=0&id=1988d3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1988d3c8",
  null
  
)

export default component.exports